import {TextButton} from '../../index'

const CloseButton = ({className, onClick}) => {
    return (
        <TextButton className={className} clickHandler={onClick}>Close</TextButton>
    )
}

export default CloseButton